import pylon from "../pylon.png"

const Visual = () => {
    return <img src={pylon} alt="pylon"/>;
  };
  
  export default Visual;